import axios from 'axios'
import AdicionarDocumentoAtaInput from '@/core/apiclient/ata/documentos-ata/documentos/editor-texto/models/AdicionarDocumentoAtaInput'

const URL_PATH = 'api/atas/documentos/documentos-editor'

class DocumentoEditorTextoApiClient {
	async adicionarDocumento(dados) {
		return await axios.post(
			`${URL_PATH}`,
			new AdicionarDocumentoAtaInput(
				dados.id,
				dados.titulo,
				dados.idTipoDocumento,
				dados.idModeloDocumento,
				dados.idAditivoApostila,
				dados.idPenalidade,
			),
		)
	}

	async buscarPorId(idDocumentoAta) {
		return await axios.get(`api/atas/documentos/${idDocumentoAta}/editor-texto`)
	}
	async redigir(idDocumento) {
		return await axios.put(`${URL_PATH}/${idDocumento}`)
	}

	async visualizar(idDocumento) {
		return await axios.get(`${URL_PATH}/${idDocumento}`)
	}

	async sincronizar(idDocumento) {
		return await axios.put(`${URL_PATH}/${idDocumento}/sincronizar`)
	}
}

export default new DocumentoEditorTextoApiClient()
